import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=3aed1e54&scoped=true&"
import script from "./LoginView.vue?vue&type=script&lang=ts&"
export * from "./LoginView.vue?vue&type=script&lang=ts&"
import style0 from "./LoginView.vue?vue&type=style&index=0&id=3aed1e54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aed1e54",
  null
  
)

export default component.exports